/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_Preview_EmptyInputs */



/**
* | output |
* | --- |
* | "Your first practice conversation appears here as soon as it is ready." |
*
* @param {Onboarding_Pilot_Ready_Preview_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_preview_empty = /** @type {((inputs?: Onboarding_Pilot_Ready_Preview_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_Preview_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je eerste oefengesprek verschijnt hier zodra het klaarstaat.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre premier entretien d’entraînement apparaît ici dès qu’il est prêt.")
	return /** @type {LocalizedString} */ ("Your first practice conversation appears here as soon as it is ready.")
});